import { useState } from 'react';
import { CaretRight, Sparkle, WarningCircle } from '@phosphor-icons/react';
import Modal from '../../../shared/components/Modal';
import './styles.css';

export type QuickAddNoticeCopy = {
  placeQuickAddBadge: string;
  placeQuickAddTitle: string;
  placeQuickAddText: string;
  gotIt: string;
  cancel: string;
};

type QuickAddNoticeProps = {
  t: QuickAddNoticeCopy;
};

export default function QuickAddNotice({ t }: QuickAddNoticeProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="quick-add-notice-trigger"
        aria-haspopup="dialog"
        onClick={() => setOpen(true)}
      >
        <WarningCircle weight="fill" />
        <span>{t.placeQuickAddBadge}</span>
        <CaretRight className="quick-add-notice-chevron" weight="bold" />
      </button>

      {open && (
        <Modal
          onClose={() => setOpen(false)}
          label={t.placeQuickAddTitle}
          closeLabel={t.cancel}
          className="quick-add-notice-dialog"
        >
          <div className="quick-add-notice-modal">
            <div className="quick-add-notice-heading">
              <span className="quick-add-notice-icon" aria-hidden="true">
                <Sparkle weight="fill" />
              </span>
              <h2>{t.placeQuickAddTitle}</h2>
            </div>
            <p className="quick-add-notice-copy">{t.placeQuickAddText}</p>
            <button type="button" className="primary full" onClick={() => setOpen(false)}>
              {t.gotIt}
            </button>
          </div>
        </Modal>
      )}
    </>
  );
}
